export default function LandingExample() {
  const fields = [
    ['Age', '56'],
    ['Gender', 'Male'],
    ['Phone', '(123) 456-8987'],
    ['Address', '1234 Main Street'],
    ['ZIP Code', '49047'],
    ['Email', 'john.doe@email.com'],
    ['Estimated Income', '$80,000/year'],
  ] as const;

  return (
    <div className="relative w-full overflow-hidden rounded-2xl border border-white/10 bg-gradient-to-br from-[#12121a] via-[#0c0c12] to-[#08080c] landing-preview">
      <div className="absolute inset-0 landing-preview-grid opacity-[0.35]" />
      <div className="relative p-5 sm:p-6 space-y-3">
        <div className="flex items-center justify-between gap-3">
          <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-gray-500">
            Input → Enriched output
          </p>
          <p className="rounded-md border border-white/10 px-2 py-0.5 text-[10px] font-medium uppercase tracking-[0.12em] text-gray-400">
            Sample data
          </p>
        </div>

        <div className="rounded-xl border border-white/[0.08] bg-black/35 px-4 py-3">
          <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-gray-500 mb-1">
            Input
          </p>
          <p className="text-sm text-white">
            <span className="font-medium">John Doe</span>
            <span className="text-gray-500"> — </span>
            <span className="text-gray-300">Charlotte, North Carolina</span>
          </p>
        </div>

        <div className="rounded-xl border border-[var(--accent)]/25 bg-black/40 px-4 py-3 space-y-2.5 landing-row">
          <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-[var(--accent)]">
            Enriched output
          </p>
          <p className="text-sm text-white font-medium">John Doe</p>
          <dl className="grid grid-cols-[auto_minmax(0,1fr)] gap-x-3 gap-y-1 text-[13px]">
            {fields.map(([label, value]) => (
              <div key={label} className="contents">
                <dt className="text-gray-500">{label}</dt>
                <dd className="text-gray-200 min-w-0 break-words">
                  {label === 'Email' ? (
                    <a
                      href="mailto:john.doe@email.com"
                      className="text-gray-200 hover:text-white underline-offset-2 hover:underline"
                    >
                      {value}
                    </a>
                  ) : (
                    value
                  )}
                </dd>
              </div>
            ))}
          </dl>
        </div>

        <p className="text-xs text-gray-500">
          Demonstration only — not a real person or contact record.
        </p>
      </div>
    </div>
  );
}
